import React from 'react'
import { Box } from '@material-ui/core'
import Text from '../../atoms/Text'

const LoadingPlaceholder = () => {
  return (
    <Box textAlign='center' minHeight='300px' alignItems='center' justifyContent='center' display='flex'>
      <Box>
        <span className='app-loader' />
        <Text text='Loading...' />
      </Box>
    </Box>
  )
}

export default LoadingPlaceholder
